import { OrgTestCountAnalytics } from "types/analyticsTypes";

export function filterOrganizationsBySearch(
  data: OrgTestCountAnalytics[],
  search: string,
): OrgTestCountAnalytics[] {
  const term = search.trim().toLowerCase();
  if (!term) return data;
  return data.filter(
    (org) =>
      (org.orgName ?? "").toLowerCase().includes(term) || org.orgId.toLowerCase().includes(term),
  );
}
